import React from "react";
import { Admin, Resource } from "react-admin";
import dataProvider from "./dataProvider";
import authProvider from "./authProvider";
import MyLayout from "components/layout/Layout";
import LoginPage from "pages/auth/LoginPageCustom";
import { createMuiTheme } from "@material-ui/core/styles";
import navModeReducer from "redux/navmode.reducer";
import navModeSaga from "redux/navmode.saga";

//pages
import users from "pages/users";
import schools from "pages/schools";
import levelGroups from "pages/levelGroups";
import levels from "pages/levels";
import areas from "pages/areas";
import busSchedules from "pages/busSchedules";
import students from "pages/students";
import parents from "pages/parents";
import rateCharts from "pages/ratecharts";
import academicYears from "pages/academicYears";
import academicTerms from "pages/academicTerms";
import holidays from "pages/holidays";
import studentAddresses from "pages/studentAddresses";
import studentSchedules from "pages/studentSchedules";
import subcontractors from "pages/subcontractors";
import vehicles from "pages/vehicles";
import drivers from "pages/drivers";
import busAssistants from "pages/busAssistants";
import notTakingStudents from "pages/notTakingStudents";
import routeplans from "pages/routeplans";
import commercialDocuments from "pages/commercialDocuments";
import assignments from "pages/assignments";
import changeRequestForms from "pages/changeRequestForms";
import unapprovedInvoices from "pages/unapprovedInvoices";
import notTakingReports from "pages/notTakingReports";
import notTakings from "pages/notTakings";
import studentPermissions from "pages/studentPermissions";
import companies from "pages/companies";
import personInCharges from "pages/personInCharges";
import emailLogs from "./pages/emailLogs";
import invoices from "./pages/invoices";
import generalLedger from "pages/generalLedger";
import creditNotes from "pages/creditNotes";
import cashReceipts from "pages/cashReceipts";
import customerReceipts from "pages/customerReceipts";
import unapprovedCreditNotes from "./pages/unapprovedCreditNotes";
import notifications from "./pages/notifications";
import dueRenewalStudents from "./pages/dueRenewalStudents";

import customRoutes from "./routes";

import { theme } from "./theme";
const customTheme = createMuiTheme(theme);

const App = () => {
  if (process.env.REACT_APP_STATUS === "STAGING") {
    console.log = function () {};
  }

  return (
    <Admin
      customReducers={{ navMode: navModeReducer }}
      customSagas={navModeSaga}
      dataProvider={dataProvider}
      customRoutes={customRoutes}
      layout={MyLayout}
      theme={customTheme}
      authProvider={authProvider}
      loginPage={LoginPage}
    >
      <Resource name="dashboard" />
      <Resource {...schools} />
      <Resource {...users} />
      <Resource {...levelGroups} />
      <Resource {...levels} />
      <Resource {...academicTerms} />
      <Resource {...academicYears} />
      <Resource {...holidays} />
      <Resource {...rateCharts} />
      <Resource {...areas} />
      <Resource {...busSchedules} />
      <Resource {...students} />
      <Resource {...studentSchedules} />
      <Resource name="studentScheduleDetails" />
      <Resource {...parents} />
      <Resource {...commercialDocuments} />
      <Resource name="billingAddress" />
      <Resource {...studentAddresses} />
      <Resource name="transactions" />
      <Resource {...subcontractors} />
      <Resource {...vehicles} />
      <Resource {...drivers} />
      <Resource {...busAssistants} />
      <Resource {...notTakingStudents} />
      <Resource {...routeplans} />
      <Resource name="customerLedgers" />
      <Resource {...assignments} />
      <Resource name="routes" />
      <Resource name="roles" />
      <Resource {...changeRequestForms} />
      <Resource {...unapprovedInvoices} />
      <Resource {...unapprovedCreditNotes} />
      <Resource {...notTakingReports} />
      <Resource {...notTakings} />
      <Resource name="payments" />
      <Resource {...studentPermissions} />
      <Resource {...companies} />
      <Resource {...personInCharges} />
      <Resource {...generalLedger} />
      <Resource {...creditNotes} />
      <Resource {...invoices} />
      <Resource {...cashReceipts} />
      <Resource {...customerReceipts} />
      <Resource {...emailLogs} />
      <Resource {...notifications} />
      <Resource {...dueRenewalStudents} />
    </Admin>
  );
};

export default App;
